<template>
  <div class="warning-modal-body">
    <NuxtLayout name="custom">
      <div class="exclamation-mark">
        <AM3Icon
          name="exclamation-triangle"
          height="70px"
        />
      </div>
      <p class="error-message text-center text-base font-medium">
        {{ error.message }}
      </p>
      <section
        class="advice-message"
      >
        <p
          class="text-center text-sm"
          v-html="adviceMsg"
        />
      </section>
    </NuxtLayout>
  </div>
</template>

<script>
// definePageMeta({
//   layout: false,
// })
export default {
  name: 'ErrorPage',

  props: {
    error: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      adviceMsg: 'Uh-oh, something went wrong!<br/>Please try again later or <a href="javascript:window.location.href=window.location.href">refresh the page</a>',
    }
  },
}
</script>

<style scoped>
.warning-modal-body {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 250px;
  padding: 20px;
}
.warning-modal-body .exclamation-mark {
  display: flex;
  justify-content: center;
  margin-bottom: 19px;
}
.warning-modal-body .error-message {
  margin-bottom: 16px;
}
.warning-modal-body .advice-message {
  display: flex;
  align-items: center;
}
</style>
